/**
 * Validates form data against field configurations
 * @param {Object} formData - The form data to validate
 * @param {Array} fields - Array of field configurations
 * @returns {Object} - { isValid: boolean, errors: Object }
 */
export const validateForm = (formData, fields) => {
  const errors = {};
  let isValid = true;

  fields.forEach(field => {
    const value = formData[field.id];
    
    // Check required fields
    if (field.required) {
      if (!value || value.toString().trim() === '') {
        errors[field.id] = 'This field is required';
        isValid = false;
        return;
      }
    }

    // Skip validation if field is empty and not required
    if (!value || value.toString().trim() === '') {
      return;
    }

    // Type-specific validation
    switch (field.type) {
      case 'email':
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          errors[field.id] = 'Please enter a valid email address';
          isValid = false;
        }
        break;
        
      case 'tel':
        const phoneRegex = /^[\d\s\-+()]+$/;
        if (!phoneRegex.test(value)) {
          errors[field.id] = 'Please enter a valid phone number';
          isValid = false;
        }
        break;
        
      default:
        // No additional validation for text, number, select
        break;
    }
  });

  return { isValid, errors };
};

/**
 * Validates a single field
 * @param {*} value - The field value
 * @param {Object} field - The field configuration
 * @returns {string|null} - Error message or null if valid
 */
export const validateField = (value, field) => {
  // Check required
  if (field.required && (!value || value.toString().trim() === '')) {
    return 'This field is required';
  }

  // Skip if empty and not required
  if (!value || value.toString().trim() === '') {
    return null;
  }

  // Type-specific validation
  switch (field.type) {
    case 'email':
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return 'Please enter a valid email address';
      }
      break;
      
    case 'tel':
      const phoneRegex = /^[\d\s\-+()]+$/;
      if (!phoneRegex.test(value)) {
        return 'Please enter a valid phone number';
      }
      break;
  }

  return null;
};
